export default "__VITE_ASSET__CYLxn9WX__"